<template>
  <div class="social-networks">
       <a target="_blank" :href="item.href" v-for="item in socials_networks" :key="`social-network-${item.icon}`">
           <component :is="item.icon" :width="iconWidth" :fill="iconFill"></component>
     </a>
  </div>
</template>

<script>
import FacebookIcon from "./Svg/FacebookIcon";
import YoutubeIcon from "./Svg/YoutubeIcon";
import LinkedinIcon from "./Svg/LinkedinIcon";
import InstagramIcon from "./Svg/InstagramIcon";
import TwitterIcon from "./Svg/TwitterIcon";


export default {
    components: {
        FacebookIcon,
        LinkedinIcon,
        YoutubeIcon,
        InstagramIcon,
        TwitterIcon,
    },

    computed: {

        socials_networks() {
            return [
                {icon: 'facebook-icon', title: 'Facebook', href: 'https://www.facebook.com/crivelliadvogados'},
                {icon: 'youtube-icon', title: 'Youtube', href: 'https://www.youtube.com/c/CrivelliAdvogadosAssociados/'},
                {icon: 'linkedin-icon', title: 'Linkedin', href: 'https://www.linkedin.com/company/2711677'},
                {icon: 'instagram-icon', title: 'Instagram', href: 'https://www.instagram.com/crivelliadvogados/'},
                {icon: 'twitter-icon', title: 'Twitter', href: 'https://twitter.com/crivelliadvoga1'}
            ]
        },

    },

    props: {
        iconWidth: { type: [Number, String], default: 35 },
        iconFill: { type: String, default: null }
    },

}
</script>
